module.exports = __webpack_public_path__ + "static/img/logo-alt.c910fdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-alt.png
// module id = geKz
// module chunks = 1